<div class="d-flex flex-column-fluid align-items-start container-xxl">
  <div class="row my-8 rounded overflow-hidden w-100 px-0 mx-0">

    <div class="col-12 col-md-12">
      <h2 class="mb-8">
        Saved Profiles
      </h2>
      <!-- <div class="row w-100 mb-8 d-flex align-items-center justify-content-between px-0 mx-0">
        <div class="fs-4 col-12 col-md-6 px-0 mx-0">
          You have <b>{{wishlistItems.length || 0}}</b> active {{wishlistItems.length == 1 ? "connection" : "connections"}}
        </div>
        <div class="my-1 col-12 col-md-6 px-0 mx-0">
          <div class="input-group">
            <input type="text" [(ngModel)]="searchText" (input)="handleSearch()" [(ngModel)]="searchText" class="form-control"
              id="inlineFormInputGroupUsername" placeholder="Search a connection">
          </div>
        </div>
      </div> -->

      <div class="col-12 col-md-12 py-20 bg-white" *ngIf="!wishlistItems.length">
        <div class="text-center mb-10">
          <i class="bi bi-exclamation-circle" style="font-size: 100px;">
          </i><br><br>
          <span class="fs-4 text-center my-4  text-gray-500">
            No saved profiles
          </span>
        </div>
      </div>

      <div class="row mb-5" *ngIf="wishlistItems.length">
        <div *ngFor="let item of wishlistItems" class="rounded px-4 pt-4 col-6 col-md-4">
          <div class="card shadow-sm">

            <div class="d-flex justify-content-between align-items-center">
              <div class="text-gray-800 fw-bolder fs-3 mb-1 ms-3">
                <div class="badge badge-light fw-bolder">
                  {{ item?.otherUserAccountType|accountTypeToLabel | uppercase }}
                </div>
              </div>

              <!-- <div ngbDropdown container="body" data-kt-user-table-toolbar="base" class="d-flex justify-content-end mt-3 me-3">
                <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                  ngbDropdownToggle data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                  <i class="bi bi-three-dots-vertical"></i>

                </button>

                <div ngbDropdownMenu
                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                  data-kt-menu="true">


                  <div class="menu-item px-5">
                    <div class="menu-link px-5 d-flex justify-content-between align-items-center" ngbDropdownItem
                      (click)="removeConnection(item)">
                      Delete
                      <i class="bi bi-trash fs-5 header-icons-font-size text-red cursor-pointer"></i>
                    </div>
                  </div>

                </div>


              </div> -->
            </div>


            <div class="d-flex flex-column align-items-center justify-content-center">
              <div class="symbol symbol-circle symbol-75px overflow-hidden cursor-pointer shadow-sm"
                (click)="openProfilePage(item)">
                <div class="symbol-label">
                  <ng-container *ngIf="item?.avatar; else nameAvatar">
                    <img [src]="(item.avatar | imagekitUrlAppender)+ '?tr=w-150,h-150,cm-pad_resize'" alt="Profile image" class="w-100" />
                  </ng-container>

                  <ng-template #nameAvatar>
                    <ngx-avatars [name]="item?.companyName" size="75">
                    </ngx-avatars>
                  </ng-template>
                </div>
              </div>

              <h2 (click)="openProfilePage(item)" class="mt-2 fs-5 text-center cursor-pointer text-truncate "
                style="width: 90%;" [ngbTooltip]="item?.companyName">
                {{item.companyName}}
              </h2>
              <div class="mt-0 d-flex align-items-center mb-4">
                {{item.otherUser?.name}}

                <!-- <div
                *ngIf="socketService.isUserOnline(item.otherPeople?.teamMembers?.[0]?.uuid)"
                 class="bg-green ms-2 rounded cursor-pointer"
                 ngbTooltip="Online"
                  style="height: 8px; width: 8px;"></div>
              </div> -->
              </div>


              <!-- <div class="mt-3 row border-top mt-3 buttonSection">
              <div class="button col-5 py-4 cursor-pointer d-flex align-items-center justify-content-center"
              *ngIf="brandDetails.features?.chat"
                [routerLink]="'/chat/conversations/' + (item.groupChatUUID || item.userUUID)">
                <i class="bi bi-chat-right-text text-black fs-4 me-3 ms-2"></i>
                Chat
              </div>
              <div class="button col-7 border-left py-4 cursor-pointer d-flex align-items-center  justify-content-center"
              [ngClass]="{
                'col-12': !brandDetails.features?.chat,
                'col-7': brandDetails.features?.chat}"
                (click)="openCreateModal(item)">
                <i class="bi bi-calendar3 text-black fs-4 me-3"></i>
                Schedule call
              </div>
            </div> -->

            </div>
          </div>
        </div>

      </div>

    </div>


  </div>
